import { JSX, useCallback } from "react";

import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import DeleteIcon from "@mui/icons-material/Delete";

import { ChangeEvent, DeleteEvent, Event } from "utils/history/Event";

import { UserRights } from "core/blueprint/trajectory/TrajectoryBlueprintService";

export interface UserRightRowProps {
	index: number;
	userRights: UserRights;
	roles: string[];
	editable: boolean;

	onChange: (event: Event) => void;
}

function UserRightRow(props: UserRightRowProps): JSX.Element {
	function split(input: string | string[]): string[] {
		if (typeof input === "string") {
			return input.split(",");
		} else {
			return input;
		}
	}

	const updateRoles = useCallback(
		(event: SelectChangeEvent<string[]>): void => {
			const value = event.target.value;
			props.onChange(
				new ChangeEvent(
					`/users/${props.index}/roles`,
					props.userRights.roles,
					split(value)
				)
			);
		},
		[props.index, props.userRights, props.onChange]
	);

	const onDelete = useCallback((): void => {
		props.onChange(
			new DeleteEvent(`/users/${props.index}`, props.userRights)
		);
	}, [props.index, props.userRights, props.onChange]);

	return (
		<TableRow>
			<TableCell component="th" scope="row">
				{props.userRights.user}
			</TableCell>
			<TableCell>
				<Select
					variant="standard"
					fullWidth
					multiple
					disabled={!props.editable}
					value={props.userRights.roles}
					onChange={updateRoles}>
					{props.roles.map(role => (
						<MenuItem key={role} value={role}>
							{role}
						</MenuItem>
					))}
				</Select>
			</TableCell>
			<TableCell padding="none" align="right">
				<IconButton
					size="small"
					disabled={!props.editable}
					onClick={onDelete}>
					<DeleteIcon fontSize="inherit"></DeleteIcon>
				</IconButton>
			</TableCell>
		</TableRow>
	);
}

export default UserRightRow;
